import { z } from 'zod';

import { CustomerRoleStatusSchema } from './customer-role.schemas.js';

export const ChangeCustomerRoleStatusBodySchema = z.object({
  toStatus: CustomerRoleStatusSchema,
  reason: z.string().trim().optional(),
});

export type ChangeCustomerRoleStatusBody = z.infer<typeof ChangeCustomerRoleStatusBodySchema>;
